import {
  DEVELOPER_HUB_PATHS,
  DEVELOPER_SECTIONS,
  developerSectionPath,
} from "./developerResources";

export const PUBLIC_MCP_ENDPOINT = "https://www.caire.se/mcp";
/** The page that holds the MCP guide; append a section anchor. */
export const MCP_GUIDE_PATHS = {
  sv: DEVELOPER_HUB_PATHS.sv,
  en: DEVELOPER_HUB_PATHS.en,
} as const;
/** Links that open the MCP section itself. */
export const MCP_GUIDE_HREFS = {
  sv: developerSectionPath("sv", "mcp"),
  en: developerSectionPath("en", "mcp"),
} as const;
export const MCP_SECTION_ANCHORS = {
  sv: {
    public: DEVELOPER_SECTIONS.mcpPublic,
    customer: DEVELOPER_SECTIONS.mcpCustomer,
  },
  en: {
    public: DEVELOPER_SECTIONS.mcpPublic,
    customer: DEVELOPER_SECTIONS.mcpCustomer,
  },
} as const;
